import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyBtn", "annualBtn", "monthlyPrice", "annualPrice", "annualNote", "subscribeBtn", "monthlyExVat", "annualExVat", "discountedMonthly", "discountedAnnual"]

  showMonthly() {
    this.monthlyBtnTargets.forEach(btn => btn.classList.add("active"))
    this.annualBtnTargets.forEach(btn => btn.classList.remove("active"))

    this.monthlyPriceTargets.forEach(el => el.classList.remove("d-none"))
    this.annualPriceTargets.forEach(el => el.classList.add("d-none"))
    this.annualNoteTargets.forEach(el => el.classList.add("d-none"))
    this.monthlyExVatTargets.forEach(el => el.classList.remove("d-none"))
    this.annualExVatTargets.forEach(el => el.classList.add("d-none"))

    this.discountedMonthlyTargets.forEach(el => el.classList.remove("d-none"))
    this.discountedAnnualTargets.forEach(el => el.classList.add("d-none"))

    this.subscribeBtnTargets.forEach(btn => {
      const url = new URL(btn.closest("form")?.action || window.location.href)
      url.searchParams.set("billing_interval", "monthly")
      if (btn.closest("form")) btn.closest("form").action = url.toString()
    })
  }

  showAnnual() {
    this.monthlyBtnTargets.forEach(btn => btn.classList.remove("active"))
    this.annualBtnTargets.forEach(btn => btn.classList.add("active"))

    this.monthlyPriceTargets.forEach(el => el.classList.add("d-none"))
    this.annualPriceTargets.forEach(el => el.classList.remove("d-none"))
    this.annualNoteTargets.forEach(el => el.classList.remove("d-none"))
    this.monthlyExVatTargets.forEach(el => el.classList.add("d-none"))
    this.annualExVatTargets.forEach(el => el.classList.remove("d-none"))

    this.discountedMonthlyTargets.forEach(el => el.classList.add("d-none"))
    this.discountedAnnualTargets.forEach(el => el.classList.remove("d-none"))

    this.subscribeBtnTargets.forEach(btn => {
      const url = new URL(btn.closest("form")?.action || window.location.href)
      url.searchParams.set("billing_interval", "annual")
      if (btn.closest("form")) btn.closest("form").action = url.toString()
    })
  }
}
